import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 3h-3V1h-2v2H7V1H5v2H2v20h20V3zm-2 18H4V8h16v13z"
}), 'CalendarTodaySharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CalendarTodaySharp.js
// module id = 2581
// module chunks = 2